export const ADD_CITIES = 'ADD_CITIES';

export const addCities = (cities) => {
  return {
    type: ADD_CITIES,
    payload: cities,
  }
};
